/**
 * Turns one side of a merge (an object of id → document Maps) into something JSON.stringify can write out, so the
 * receiver's documents can be snapshotted to S3 exactly as the merge saw them, before anything is written back.
 * Maps become arrays of their values; every other property is copied as is.
 */
export function serializeMergeData(mergeData: Record<string, unknown>): Record<string, unknown> {
	const serialized: Record<string, unknown> = {};
	for (const [key, value] of Object.entries(mergeData)) {
		serialized[key] = value instanceof Map ? Array.from(value.values()) : value;
	}
	return serialized;
}

export default serializeMergeData;
